<template>
  <section :class="['pillar-section', pillarClass]">
    <div class="pillar-header">
      <div class="pillar-title">
        <div class="pillar-icon">{{ header.icon }}</div>
        <div>
          <h2>{{ header.title }}</h2>
          <p>{{ header.subtitle }}</p>
        </div>
      </div>
      <span class="completion-badge">{{ completion }}</span>
    </div>
    <div class="cards-grid">
      <div v-for="(card, i) in cards" :key="i" class="activity-card">
        <div class="activity-header">
          <div class="activity-meta">
            <span class="activity-type">{{ card.type }}</span>
            <span class="activity-points">{{ card.points }} XP</span>
          </div>
          <span class="activity-status">{{ card.icon }}</span>
        </div>
        <h3>{{ card.title }}</h3>
        <p>{{ card.description }}</p>
        <div class="activity-progress">
          <div class="activity-progress-fill" :style="{ width: card.progress + '%' }"></div>
        </div>
        <div class="activity-footer">
          <span>Progression</span>
          <span>{{ card.points }} XP</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "PillarSection",
  props: {
    pillar: { type: String, required: true },
    header: { type: Object, required: true },
    completion: { type: String, required: true },
    cards: { type: Array, required: true },
  },
  computed: {
    pillarClass() {
      return (
        {
          apprentissage: "pillar-1",
          validation: "pillar-2",
          defis: "pillar-3",
        }[this.pillar] || "pillar-1"
      )
    },
  },
}
</script>
<style scoped>
.pillar-section {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.pillar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 3px solid #e2e8f0;
}
.pillar-title {
  display: flex;
  align-items: center;
  gap: 15px;
}
.pillar-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
}
.pillar-1 .pillar-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}
.pillar-2 .pillar-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}
.pillar-3 .pillar-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}
.pillar-title h2 {
  color: #2d3748;
  font-size: 22px;
}
.pillar-title p {
  color: #718096;
  font-size: 14px;
}
.completion-badge {
  background: #f7fafc;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #667eea;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}
.activity-card {
  background: #f7fafc;
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
}
.activity-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  border-color: #667eea;
}
.activity-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}
.activity-meta {
  display: flex;
  gap: 10px;
  align-items: center;
}
.activity-type {
  background: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  color: #667eea;
}
.activity-points {
  background: linear-gradient(135deg, #ffd89b 0%, #f59e0b 100%);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  color: white;
}
.activity-status {
  font-size: 20px;
}
.activity-card h3 {
  color: #2d3748;
  font-size: 16px;
  margin-bottom: 10px;
}
.activity-card p {
  color: #718096;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 15px;
}
.activity-progress {
  background: #e2e8f0;
  height: 6px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 8px;
}
.activity-progress-fill {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  height: 100%;
  border-radius: 10px;
  transition: width 0.5s ease;
}
.activity-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #718096;
}
</style>
